import ClearIndicator from '@/elements/Select/variants/primary/components/ClearIndicator';
import DropdownIndicator from '@/elements/Select/variants/primary/components/DropdownIdicator';
import Option from '@/elements/Select/variants/primary/components/Option';

export default { DropdownIndicator, Option, ClearIndicator };
